import React from 'react';

import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';

import ScrollIndicator from '../../ScrollIndicator';

import './style.scss';

const Intro = ({ title, body, backgroundImage, backgroundImageMobile, onStart = null }) => {
  return (
    <div className="AnnualReport__introduction">
      <div className="AnnualReport__introduction__wrapper">
        <Container>
          <div className="AnnualReport__introduction__content">
            <h1>{title}</h1>
            <p>{body}</p>
            {onStart && <ScrollIndicator onClick={onStart} />}
          </div>
        </Container>
        <div className="AnnualReport__introduction__content__image">
          <Image src={{
            '1200': backgroundImage,
            '0': backgroundImageMobile,
          }} />
        </div>
      </div>
    </div>
  );
};

export default Intro;
